import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DataService } from '../services/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-module-training',
  templateUrl: './module-training.component.html',
  styleUrls: ['./module-training.component.scss']
})


export class ModuleTrainingComponent implements OnInit {
  constructor(private dataService: DataService, private modalService: NgbModal) { }
  @Input() trngMdlRef: any;
  @Input() moduleTrainingVideoActions: any;
  @Input() trainingModule: any;
  
  ngOnInit(): void {
    this.trainingModule = this.dataService.trainingModule;
    console.log(this.trainingModule);
  }

  changeVideoActions(action: string, moduleID: number) {
    if (action == 'stop') {
      this.modalService.dismissAll();
    }
    this.dataService.trainingVideoActions(action, moduleID);
  }

}
